import { Component, OnInit, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Api } from "../../common/api";
import { Constants } from "../../common/constants";
import { IProperty } from "../../common/property";
import { MainService } from "../../services/main.service";

@Component({
  selector: "app-enquiry",
  templateUrl: "./enquiry.component.html",
  styleUrls: ["./enquiry.component.scss"],
})
export class EnquiryComponent implements OnInit {
  value: any;
  categoryData: any;
  pageChangedNumber: number;
  itemsPerPageValue: number;
  public parameter: IProperty = {};
  modelCustomize: any;
  model: any;
  modalRef: BsModalRef;
  deleteId: any;
  deleteUserName: string;
  config: any;

  constructor(
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private mainService: MainService,
    private api: Api,
    public constants: Constants,
    private router: Router
  ) {
    this.parameter.page = 1;
    this.config = {
      backdrop: true,
      ignoreBackdropClick: true,
      animated: true,
      keyboard: false,
    };
  }

  getPage(page) {
    this.parameter.page = page;
  }

  pageChanged(event: any): void {
    this.pageChangedNumber = event.page;
    this.itemsPerPageValue = event.itemsPerPage;
  }

  ngOnInit(): void {
    this.getEnquiries();
  }

  getEnquiries() {
    const offset =
      this.parameter.page * this.constants.itemsPerPage -
      this.constants.itemsPerPage;
    const input = {
      limit: this.constants.itemsPerPage,
      skip: offset,
    };
    this.mainService
      .getDataAptWithParams(this.api.paths.getEnquiries, input)
      .subscribe((success) => {
        this.modelCustomize = success["data"];
        this.parameter.total = success["total"];
      });
  }

  opendeletemodal(id, template: TemplateRef<any>, customerName?: string) {
    this.deleteId = id;
    this.deleteUserName = customerName || "this enquiry";
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "gray modal-md" }, this.config)
    );
  }

  delete(delId) {
    this.spinner.show();
    this.mainService
      .deleteDataApi(this.api.paths.deleteEnquiry + "?enquiryId=" + delId, {})
      .subscribe(
        (success) => {
          this.spinner.hide();
          this.modalRef.hide();
          this.toastrService.success(
            success["message"] || "Enquiry deleted successfully"
          );
          this.getEnquiries();
        },
        (error) => {
          this.spinner.hide();
          this.modalRef.hide();
          this.toastrService.error(
            error.error?.message || "Error deleting enquiry. Please try again."
          );
          console.error("Delete error:", error);
        }
      );
  }
}

